import {
  QueryDocumentSnapshot,
  DocumentSnapshot,
  DocumentData,
  FirestoreDataConverter,
} from 'firebase/firestore';

type Document = QueryDocumentSnapshot<DocumentData> | DocumentSnapshot<DocumentData>;

export function firestoreDateMapper<T extends DocumentData>(
  doc: Document,
  mapper?: (data: T) => T
): T {
  if (!doc.exists()) {
    throw new Error('Document not exists');
  }

  const data = mapper ? mapper(doc.data() as T) : (doc.data() as T);

  return {
    ...data,
    id: doc.id,
    createdAt: data.createdAt ? data.createdAt.toDate?.() : new Date(),
    updatedAt: data.updatedAt ? data.updatedAt.toDate?.() : new Date(),
  };
}

function transformFirestoreTimestampIntoDateInCollection<T extends object>(
  document: QueryDocumentSnapshot<DocumentData>,
  mapper?: (data: T) => T
) {
  const data = mapper ? mapper(document.data() as T) : document.data();

  return {
    id: document.id,
    ...data,
    createdAt: 'createdAt' in data ? data.createdAt?.toDate() : null,
    updatedAt: 'updatedAt' in data ? data.updatedAt?.toDate() : null,
  } as T;
}

export function getDocumentConverter<T extends object>(
  mapper?: (data: T) => T
): FirestoreDataConverter<T> {
  return {
    toFirestore: (document: T) => document,
    fromFirestore: (document) =>
      transformFirestoreTimestampIntoDateInCollection<T>(document, mapper),
  };
}
